export default "__VITE_ASSET__DOiAmTM___"